/**
 * ArgumentNullException      NullException         400
 * ArgumentException          ValidationError       400
 * KeyNotFoundError           NotFoundError         404
 * OperationCanceledException NotProcessedOperation 403
 * Conflict                                         409
 * Ok                         CorrectOperation      200
 * Otras                      UnKnowError           500
 *                            OperationError        500
 */
import Router from '@/router';
import Utils from '@/components/shared/helpers/Utils.js';

export function handleError (err) {
  let errObject = { message: 'Error de respuesta del servidor' };
  let errorMessage = null;
  if (err.response !== null && err.response !== undefined) {
    if (!err.response.data.error.errorMessage) errorMessage = Utils.isJson(err.response.data.error) ? JSON.parse(err.response.data.error).errorMessage ? JSON.parse(err.response.data.error).errorMessage : null : null;
    if (!errorMessage) errorMessage = err.response.data.error ? err.response.data.error : null;
    errObject.status = err.response.status;
    errObject.message = errorMessage;
  }

  return errObject;
};

export function handleRedirect (e) {
  const statusError = e.status ? e.status : null;
  if (!statusError) return;

  switch (statusError) {
    case 401:
      Router.push({ name: '401' });
      break;
    case 404:
      Router.push({ name: '404' });
      break;
    default:
      break;
  }
}
